module.exports = __WEBPACK_EXTERNAL_MODULE_https_views_development_octoprism_com_shell_remoteEntry_js_fefa8de9__;